import {ENDPOINT_URL} from 'constants/index';
import getFetchOptions from 'utils/getFetchOptions';
import {apiErrorHandling} from 'utils/apiUtils';

export default function getMyGroups(id) {
	return fetch(
		`${ENDPOINT_URL}/getmygroups/${id}`,
		getFetchOptions({
			method: 'GET',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
